const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;

export const apiClient = {
    async syncData(payload) {
        try {
            const token = localStorage.getItem('df_auth_token');
            const response = await fetch(API_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                },
                body: JSON.stringify({
                    ...payload,
                    timestamp: new Date().toISOString()
                })
            });

            if (!response.ok) {
                if (response.status === 401) throw new Error('Unauthorized');
                throw new Error('Server Error');
            }

            return await response.json();
        } catch (error) {
            if (!navigator.onLine) throw new Error('Offline');
            throw error;
        }
    }
};
